export enum ComplianceComparisonFundLabelKeys {
  Beta = 'beta',
  Classification = 'classification',
  InceptionDate = 'inception',
  MER = 'mer',
  OneYear = '1Y',
  RiskRating = 'risk',
  Symbol = 'symbol',
  ThreeYear = '3Y',
  TNA = 'tna',
}

export enum ComplianceComparisonStockLabelKeys {
  Beta = 'beta',
  Capitalization = 'capitalization',
  Country = 'country',
  DistributionYield = 'distributionYield',
  FiveYear = '5Y',
  Industry = 'industry',
  OneYear = '1Y',
  PB = 'pb',
  PE = 'pe',
  StdDev = 'stdDev',
  Symbol = 'symbol',
  ThreeYear = '3Y',
}
